import {
  ACESFilmicToneMapping,
  AgXToneMapping,
  CineonToneMapping,
  CustomToneMapping,
  LinearSRGBColorSpace,
  LinearToneMapping,
  NeutralToneMapping,
  NoColorSpace,
  NoToneMapping,
  ReinhardToneMapping,
  SRGBColorSpace,
} from 'three'
import type { ColorSpace, ToneMapping as ThreeJSToneMapping } from 'three'

import { OutputColorSpace, ToneMapping } from './types'

export const DEFAULT_CANVAS_CONTROLS = {
  near: 1,
  far: 2000,
}

export const DEFAULT_FREE_FORM_CAMERA_CONTROLS = {
  maxDistance: Infinity,
  minDistance: 0,
  minPolarAngle: 0.0,
  maxPolarAngle: Math.PI,
}

export const DEFAULT_CAMERA_CONTROLS = {
  maxDistance: 600,
  minDistance: 100,
  minPolarAngle: 0.0,
  maxPolarAngle: 1.5,
}

export const CAMERA_SLIDE_SPRING_CONFIG = {
  mass: 1,
  tension: 280,
  friction: 40,
}

export const DEFAULT_GL_CONTROLS = {
  toneMapping: AgXToneMapping,
  toneMappingExposure: 0.85,
  outputColorSpace: SRGBColorSpace,
}

export const DEFAULT_ENVIRONMENT_CONTROLS = {
  background: true,
  backgroundIntensity: 1,
  backgroundBlurriness: 1,
  environmentIntensity: 0.4,
}

export const DEFAULT_AMBIENT_LIGHT_CONTROLS = {
  active: true,
  intensity: 4,
  color: '#fff7f2',
}

export const DEFAULT_LOADER_TIMEOUT = 2000

export const FOCUS_OVERLAY_CONTROLS = {
  color: '#eeeeee',
  opacity: 0.6,
  stencilRef: 1,
  cutoutRenderOrder: 1000,
  overlayRenderOrder: 1001,
}

export const ToneMappingMap: Record<`${ToneMapping}`, ThreeJSToneMapping> = {
  [ToneMapping.NoToneMapping]: NoToneMapping,
  [ToneMapping.LinearToneMapping]: LinearToneMapping,
  [ToneMapping.ReinhardToneMapping]: ReinhardToneMapping,
  [ToneMapping.CineonToneMapping]: CineonToneMapping,
  [ToneMapping.ACESFilmicToneMapping]: ACESFilmicToneMapping,
  [ToneMapping.AgXToneMapping]: AgXToneMapping,
  [ToneMapping.NeutralToneMapping]: NeutralToneMapping,
  [ToneMapping.CustomToneMapping]: CustomToneMapping,
}

export const OutputColorSpaceMap: Record<`${OutputColorSpace}`, ColorSpace> = {
  [OutputColorSpace.NoColorSpace]: NoColorSpace,
  [OutputColorSpace.LinearSRGBColorSpace]: LinearSRGBColorSpace,
  [OutputColorSpace.SRGBColorSpace]: SRGBColorSpace,
}
